import { IngredientCategory } from "./types";

export const INGREDIENT_CATEGORY_MAP = {
  dairy: { label: "Dairy", color: "blue" as const },
  stabilizer: { label: "Stabilizer", color: "slate" as const },
  emulsifier: { label: "Emulsifier", color: "slate" as const },
  egg: { label: "Egg", color: "yellow" as const },
  sweetener: { label: "Sweetener", color: "fuchsia" as const },
  fruit: { label: "Fruit", color: "lime" as const },
  nut: { label: "Nuts & Seeds", color: "amber" as const },
  alcohol: { label: "Alcohol", color: "cyan" as const },
  chocolate: { label: "Chocolate", color: "orange" as const },
  other: { label: "Other", color: "gray" as const },
} satisfies Record<IngredientCategory, { label: string; color: string }>;

export const getCategoryLabel = (category: IngredientCategory) => {
  return INGREDIENT_CATEGORY_MAP[category].label;
};

export const getCategoryList = (): IngredientCategory[] => {
  return [
    "dairy",
    "egg",
    "sweetener",
    "stabilizer",
    "emulsifier",
    "alcohol",
    "fruit",
    "chocolate",
    "nut",
    "other",
  ];
};

export const sortByIngredientCategory = <T>(
  items: readonly T[],
  getCategory: (item: T) => IngredientCategory,
): T[] =>
  getCategoryList().flatMap((category) =>
    items.filter((item) => getCategory(item) === category),
  );

export const getCategoryColor = (category: IngredientCategory) => {
  return INGREDIENT_CATEGORY_MAP[category].color;
};
